import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails, MagiisAccessCarrierProfileCarrierRequestDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class UpdateMagiisAccessCarrierProfileAccess extends IRequestCommand<
  IUpdateMagiisAccessCarrierProfileAccessResponse,
  ErrorDetails,
  IUpdateMagiisAccessCarrierProfileAccessParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;

  override setParameters(parameters: IUpdateMagiisAccessCarrierProfileAccessParameters) {
    this._commandBody = parameters;
    this.urlSections.push('magiisaccess');
    this.urlSections.push(`carrierprofileaccess`);
    this.composeUrl();
  }
}

export type IUpdateMagiisAccessCarrierProfileAccessParameters = MagiisAccessCarrierProfileCarrierRequestDTO

export interface IUpdateMagiisAccessCarrierProfileAccessResponse extends ICommandResponse {

}
